import Restful from '../utils/restful.js'
const project = 'sci/'

const partner = new Restful(project, 'partner')
export default partner
